<template>
  <div>
    <h1>View facility</h1>
    <div v-if="!facility">
      Loading, please wait...
    </div>
    <div v-else>
      <div class="card">
        <div class="card-header">Facility Information</div>
        <div class="card-body">
          <b-row>
            <b-col cols="3">
              <BaseTextOutput label="Facility name" :value="facility.name"/>
            </b-col>
            <b-col cols="3">
              <BaseTextOutput label="Street Adress" :value="facility.address"/>
            </b-col>
            <b-col cols="3">
              <BaseTextOutput label="City" :value="facility.city"/>
            </b-col>
            <b-col cols="3">
              <BaseTextOutput label="Zip code" :value="facility.zipCode"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="3">
              <BaseTextOutput label="Facility email" :value="facility.email"/>
            </b-col>
            <b-col cols="3">
              <BaseTextOutput label="Provider HFID" :value="facility.hfid"/>
            </b-col>
            <b-col cols="6">
              <BaseTextOutput label="Provider type" :value="facilityType"/>
            </b-col>
          </b-row>
        </div>
      </div>
      <div class="card">
        <div class="card-header">Admin information</div>
        <div class="card-body">
          <div v-if="!facility.admin">
          <p>No admin assigned</p>
          <b-row>
            <b-col>
              <b-button :variant="showAddAdminPanel?'secondary':'primary'" @click="showAddAdminPanel=!showAddAdminPanel">{{showAddAdminPanel?'Close':'Add admin'}}</b-button>
            </b-col>
          </b-row>
            <div v-if="showAddAdminPanel">
              <b-row>
                <b-col cols="3">
                  <BaseTextInput v-model="newAdmin.email" label="Email" :v="$v.newAdmin.email"/>
                </b-col>
                <b-col cols="3">
                  <BaseTextInput v-model="newAdmin.lastName" label="Last name" :v="$v.newAdmin.lastName"/>
                </b-col>
                <b-col cols="3">
                  <BaseTextInput v-model="newAdmin.firstName" label="First name" :v="$v.newAdmin.firstName"/>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-button variant="primary" :disabled="disableButtons" @click="submit('addAdmin', null, newAdmin.email, newAdmin.lastName, newAdmin.firstName)">Submit</b-button>
                </b-col>
              </b-row>
            </div>
          </div>
          <div v-else>
            <b-row>
              <b-col cols="4">
                <BaseTextOutput label="Email" :value="facility.admin.email"/>
              </b-col>
              <b-col cols="4">
                <BaseTextOutput label="First name" :value="facility.admin.firstName"/>
              </b-col>
              <b-col cols="4">
                <BaseTextOutput label="Last name" :value="facility.admin.lastName"/>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-button variant="secondary" :disabled="disableButtons" class="mr-1r" @click="submit('demote', facility.admin.idmId, facility.admin.userEmail, facility.admin.lastName, facility.admin.firstName)">Demote to user</b-button>
                <b-button variant="danger" :disabled="disableButtons" class="mr-1r" @click="submit('delete', facility.admin.idmId, facility.admin.userEmail, facility.admin.lastName, facility.admin.firstName)">Delete</b-button>
                <a class="btn btn-primary mr-1r" :href="'/viewUser/'+facility.admin.idmId" target="_blank">View</a>
              </b-col>
            </b-row>
          </div>
        </div>
        <div class="card">
          <div class="card-header">User information</div>
          <div class="card-body">
            <div v-if="!facility.users || facility.users.length===0">
              <p>No authorized users found</p>
              <hr/>
            </div>
            <div v-else>
              <div v-for="(user, index) in facility.users" :key="index">
                <p>User {{index+1}} of {{facility.users.length}}</p>
                <b-row>
                  <b-col cols="3">
                    <BaseTextOutput label="Email" :value="user.email"/>
                  </b-col>
                  <b-col cols="3">
                    <BaseTextOutput label="First name" :value="user.firstName"/>
                  </b-col>
                  <b-col cols="3">
                    <BaseTextOutput label="Last name" :value="user.lastName"/>
                  </b-col>
                  <b-col cols="3">
                    <BaseTextOutput label="Enabled" :value="user.enabled?'Yes':'No'"/>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <span :id="'promote'+index">
                      <b-button variant="primary" class="mr-1r" :id="'promote'+index" :disabled="hasAdmin || disableButtons" @click="submit('promote', user.idmId, user.email, user.lastName, user.firstName)">Promote to admin</b-button>
                    </span>
                    <b-button variant="secondary" class="mr-1r" v-if="user.enabled" :disabled="disableButtons" @click="submit('deactivate', user.idmId, user.email, user.lastName, user.firstName)">Deactivate</b-button>
                    <b-button variant="secondary" class="mr-1r" v-else :disabled="disableButtons" @click="submit('activate', user.idmId, user.email, user.lastName, user.firstName)">Reactivate</b-button>
                    <b-button variant="danger" class="mr-2" :disabled="disableButtons" @click="submit('delete', user.idmId, user.email, user.lastName, user.firstName)">Delete</b-button>
                    <a class="btn btn-primary mr-1r" :href="'/viewUser/'+user.idmId" target="_blank">View</a>
                  </b-col>
                </b-row>
                <b-tooltip :target="'promote'+index" v-if="hasAdmin">Facility already has an admin, demote or delete before promoting</b-tooltip>
                <hr/>
              </div>
            </div>
            <b-row>
              <b-col>
                <b-button :variant="showAddPanel?'secondary':'primary'" @click="showAddPanel = !showAddPanel">{{showAddPanel?'Close':'Add user'}}</b-button>
              </b-col>
            </b-row>
            <div v-if="showAddPanel">
              <b-row>
                <b-col cols="3">
                  <BaseTextInput v-model="newUser.email" label="Email" :v="$v.newUser.email"/>
                </b-col>
                <b-col cols="3">
                  <BaseTextInput v-model="newUser.lastName" label="Last name" :v="$v.newUser.lastName"/>
                </b-col>
                <b-col cols="3">
                  <BaseTextInput v-model="newUser.firstName" label="First name" :v="$v.newUser.firstName"/>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-button variant="primary" :disabled="disableButtons" @click="submit('add', null, newUser.email, newUser.lastName, newUser.firstName)">Submit</b-button>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </div>
   </div>
  </div>
</template>

<script>
import BaseTextOutput from "@/components/templates/input/BaseTextOutput.vue";
import axios from "axios";
import BaseTextInput from "@/components/templates/input/BaseTextInput.vue";
import {email, required} from "vuelidate/lib/validators";
import axiosRetry from "axios-retry";

axiosRetry(axios, { retries: 0,
  retryDelay: axiosRetry.exponentialDelay  })

export default {
  name: "ViewFacility",
  components: {BaseTextInput, BaseTextOutput},
  data: ()=>({
    facility: null,
    facilityTypes:[
      {value: "NF", text: 'Nursing Facility'},
      {value: "SNF", text: 'Skilled Nursing Facility'},
      {value: "NH", text: "Nursing Home"},
      {value: "SNFNF", text: "Skilled Nursing Facility/Nursing Facility"},
      {value: "BCH", text: "Board & Care Home"}
    ],
    showAddPanel: false,
    newUser:{
      email: '',
      firstName: '',
      lastName: ''
    },
    showAddAdminPanel: false,
    newAdmin:{
      email: '',
      firstName: '',
      lastName: ''
    },
    disableButtons: false

  }),
  methods: {
    loadFacility(){
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/admin/facility/${this.$route.params.id}`)
          .then(response=>{
            this.facility = response.data;
          })
    },
    showRootToast(title, message, type) {
      this.$root.$bvToast.toast(message, {
        title: title,
        toaster: 'b-toaster-top-center',
        solid: true,
        variant: type,
        appendToast: true,
        noAutoHide:true
      })
      this.toastFocus()
    },
    toastFocus() {
      setTimeout(() => {
        let elem = document.getElementsByClassName("toast")
        elem = elem[elem.length-1]
        elem.focus()
      }, 100)
    },
    submit(action, userId, userEmail, userLastName, userFirstName){
      switch(action) {
        case "add":
          this.$v.newUser.$touch();
          if (this.$v.newUser.$error) {
            this.showRootToast("Missing or invalid fields", "Unable to create new user, some of the fields are missing or incorrect", "warning");
            return;
          }
          break;
        case "addAdmin":
          this.$v.newAdmin.$touch();
          if (this.$v.newAdmin.$error) {
          this.showRootToast("Missing or invalid fields", "Unable to create new admin, some of the fields are missing or incorrect", "warning");
          return;
          }
          break;
      }
      this.disableButtons = true;
      let payload = {
        action: action,
        providerId: this.$route.params.id,
        userId: userId,
        userEmail: userEmail,
        userLastName: userLastName,
        userFirstName: userFirstName
      };
      axios.post(`${process.env.VUE_APP_API_BASE_URL}/admin/user`, payload)
          .then(response => {
            switch(action){
              case "add":
                this.showRootToast("User added", "User has been successfully added to this facility", "success");
                break;
              case "addAdmin":
                this.showRootToast("Admin added", "Admin has been successfully added to this facility", "success");
                break;
              case "promote":
                this.showRootToast("User promoted", "User has been successfully promoted to administrator", "success");
                break;
              case "demote":
                this.showRootToast("Admin demoted", "Admin has been successfully demoted to user", "success");
                break;
              case "activate":
                this.showRootToast("User reactivated", "User has been successfully reactivated", "success");
                break;
              case "deactivate":
                this.showRootToast("User deactivated", "User has been successfully deactivated", "success");
                break;
              case "delete":
                this.showRootToast("User deleted", "User has been successfully deleted from this facility", "success");
                break;
            }
            this.loadFacility();
          })
          .catch(error => {
            let header;
            let body;
            switch(action){
              case "add":
                header = "Error adding user";
                break;
              case "addAdmin":
                header = "Error adding admin";
                break;
              case "promote":
                header = "Error promoting user";
                break;
              case "demote":
                header = "Error demoting user";
                break;
              case "activate":
                header = "Error reactivating user";
                break;
              case "deactivate":
                header = "Error deactivating user";
                break;
              case "delete":
                header = "Error deleting user";
                break;
              default:
                header = "Incorrect operation error";
            }
            switch(error.response.status){
              case 404:
                if(error.response.data.message==='provider'){
                  body="Provider not found";
                }
                else if(error.response.data.message==='user'){
                  body='User not found';
                }
                else{
                  body='Server returned 404. Possibly user account being referenced was deleted?'
                }
                break;
              case 409:
                if(error.response.data.message === 'adminExists'){
                  body="Admin already exists for this facility";
                }
                else{
                  body="User with this email already exists with role "+error.response.data.message;
                }
                break;
              default:
                body="An expected error occured, server returned code "+error.response.status
            }
            this.showRootToast(header, body, "danger");
      }).finally(()=>{
        this.disableButtons=false;
        this.showAddPanel=false;
        this.showAddAdminPanel=false;
        this.disableButtons=false;
      })


    }
  },
  computed:{
    hasAdmin(){
      return !!this.facility.admin;
    },
    facilityType(){
      let temp = this.facilityTypes.find(x=>x.value===this.facility.type);
      if(temp){
        return temp.text;
      }
      return "Unknown";
    }
  },
  validations(){
    return {
      newUser: {
        email: {required, email},
        firstName: {required},
        lastName: {required}
      },
      newAdmin:{
        email: {required, email},
        firstName: {required},
        lastName: {required}
      }
    }
  },
  created() {
    this.loadFacility();
  }
}
</script>



<style scoped>

</style>